// extracted by mini-css-extract-plugin
export var actions = "_1o-0";
export var actionsContainer = "_1o-7";
export var border = "_1o-1";
export var childFullHeight = "_1o-f";
export var collapse = "_1o-2";
export var content = "_1o-a";
export var contentChild = "_1o-e";
export var fullscreen = "_1o-c";
export var hasLeftRadius = "_1o-k";
export var headerContainer = "_1o-3";
export var headerRow = "_1o-5";
export var hidePadding = "_1o-b";
export var navCollapsedGap = "_1o-l";
export var noScrollX = "_1o-m";
export var noScrollY = "_1o-n";
export var noTopPadding = "_1o-i";
export var optOutTopPadding = "_1o-d";
export var pageMain = "_1o-j";
export var pageOuter = "_1o-g";
export var pagePadding = "_1o-8";
export var pageScroll = "_1o-9";
export var profile = "_1o-o";
export var profileContainer = "_1o-p";
export var profileImage = "_1o-q";
export var profileMain = "_1o-r";
export var profileSubtitle = "_1o-t";
export var profileTitle = "_1o-s";
export var showLeftPadding = "_1o-h";
export var tabsPortalSlot = "_1o-6";
export var tabsWrapper = "_1o-4";
export var title = "_1o-u";